import { ReactComponent as AboveHeadLiftSvg } from './svgs/above_head_lift.svg';

export default function ThreePeopleIcon () {
    return (
        <AboveHeadLiftSvg />
    )
} 